import { Component, EventEmitter, Input, Output } from '@angular/core';
import Article from 'src/smoothr-web-app-core/models/Article';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import Order from 'src/smoothr-web-app-core/models/Order';

@Component({
	selector: 'app-loyalty-items-render',
	templateUrl: './loyalty-items-render.component.html',
	styleUrls: ['./loyalty-items-render.component.scss'],
})
export class LoyaltyItemsRenderComponent {
	constructor() {}
	@Input() ashPointItems: Article[] = [];
	@Output() buttonClick = new EventEmitter<Article>();
	@Input() customer: Customer;
	@Input() order: Order;
	@Input() amountOfPoints = 0;
	selectItem(item: Article) {
		this.buttonClick.emit(item);
	}
	ifUserCanOrderArticle(article: Article): number {
		return article.isPiggyLoyalty && article?.piggyReward?.required_credits > 0 && !this.customer?.isAnonymous
			? this.customer?.piggyPoints - (this?.customer?.usedPiggyPoints ?? 0) - article?.piggyReward?.required_credits
			: 0;
	}
	howManyPointsLeft(article) {
		if (article.isPiggyLoyalty && article?.piggyReward?.required_credits > 0 && !this.customer?.isAnonymous) {
			return this.customer?.piggyPoints - article?.piggyReward?.required_credits;
		} else {
			return 0;
		}
	}
}
